import React, { useState } from 'react'
import View from './view'
import Edit from './edit'
import isStudent from '../../../utilities/is-student'

const GradeField = ({
    user = {},
    canEdit
}) => {

    const [ isEditing, setEditing ] = useState(false)

    if (!isStudent(user)) {
        return null
    }

    if (isEditing) {
        return (<Edit user={user} onClose={() => setEditing(false)} />)
    }

    return (
        <View user={user} onEdit={() => setEditing(true)} disabled={!canEdit} />
    )

}

export default GradeField